import React, { useState } from "react";
import { useAuth } from "./AuthContext";

const FONT = "Roboto, 'Segoe UI', Arial, sans-serif";
const DARK = "#1A1A1A";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errore, setErrore] = useState("");
  const [attesa, setAttesa] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErrore("");
    setAttesa(true);
    try {
      await login(username.trim(), password);
    } catch (err) {
      setErrore(err.message || "Accesso non riuscito");
    } finally {
      setAttesa(false);
    }
  };

  return (
    <div style={{
      fontFamily: FONT, minHeight: "100vh", background: DARK,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 20,
    }}>
      <form onSubmit={submit} style={{
        background: "#fff", borderRadius: 14, padding: "40px 36px",
        width: "100%", maxWidth: 380, boxShadow: "0 8px 40px rgba(0,0,0,0.45)",
        display: "flex", flexDirection: "column", alignItems: "center", gap: 18,
      }}>
        <img src="/logo_impj.png" alt="Imab Project" style={{ height: 64, objectFit: "contain" }} />
        <div style={{ fontWeight: 700, fontSize: 22, color: DARK, letterSpacing: 0.3 }}>
          Pianificazione Container
        </div>

        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 12, marginTop: 6 }}>
          <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 13, color: "#546E7A" }}>
            Utente
            <input
              value={username}
              onChange={e => setUsername(e.target.value)}
              autoFocus
              autoComplete="username"
              style={inputStyle}
            />
          </label>
          <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 13, color: "#546E7A" }}>
            Password
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              style={inputStyle}
            />
          </label>
        </div>

        {errore && (
          <div style={{ color: "#C62828", fontSize: 13, width: "100%", textAlign: "center" }}>
            {errore}
          </div>
        )}

        <button
          type="submit"
          disabled={attesa || !username || !password}
          style={{
            width: "100%", marginTop: 6, padding: "12px 0",
            background: attesa ? "#90A4AE" : DARK, color: "#fff",
            border: "none", borderRadius: 8, fontWeight: 700, fontSize: 16,
            cursor: attesa ? "default" : "pointer", fontFamily: FONT,
          }}
        >
          {attesa ? "Accesso…" : "Accedi"}
        </button>
      </form>
    </div>
  );
}

const inputStyle = {
  padding: "10px 12px", border: "1px solid #CFD8DC", borderRadius: 8,
  fontSize: 15, fontFamily: FONT, outline: "none",
};
